export const GLOBAL_LANGUAGE = {
    es: {
        banner_login: {
            p1: "Tu compañía avanza,",
            p2: "con Colurs haces la",
            p3: "diferencia.",
        },
        login: {
            title: "Usa tu correo electrónico para ingresar",
            label_email: "Correos Electrónico",
            placeholder_email: "correo@email.com",
            placeholder_password: "Ingresa tu contraseña",
            label_password: "Contraseña",
            button_login: "Ingresar",
            buton_register: "Crear cuenta nueva",
            tyc: "Términos y condiciones",
            request_password: "Restablecer contraseña",
            label_button_login: "Ingresar",
            error_message: "La combinación de credenciales no tiene una cuenta activa",

        },
        input_date: {
            placeholder: "Seleccione  año, mes y día"
        },
        upload_pdf: {
            alert_pdf: "Por favor, selecciona un archivo PDF de máximo 15 MB.",
            title: "Arrastra tu archivo a este espacio o cárgalo desde tu PC haciendo",
            click: "clic aquí",
            subtitle: "Formato PDF (máx. 15.0 MB)",
            change_file: "Cambiar archivo",
            read_only: "Archivo cargado"
        },
        inputselect_search: {
            placeholder: "Selecciona una opción",
            search_placeholder: "Buscar..."
        },
        register: {
            title: "escanea el código QR"
        },
        two_factor: {
            title: "Ingresa el código de seguridad",
            description: "Ingrese el código de un solo uso que aparece en la aplicación de autenticación: "
        },
        request_password: {
            title: "Recuperar contraseña",
            subtitle: "Ingresa el correo con el que registraste tu cuenta de Colurs. Muy pronto recibirás una nueva contraseña: ",
            label_email: "Correo electrónico",
            button_confirm: "Pedir nueva contraseña",
            button_back: "Volver",
            placeholder_email: "tucorreo@gmail.com",
            error_message: "Debe ingrsar un correo electronico valido"
        },
        success_recovery: {
            title: "Correo de recuperación de contraseña enviado",
            description: "Hemos enviado un correo electrónico a la dirección registrada en su cuenta con las instrucciones para restablecer su contraseña. Por favor, revise su bandeja de entrada y, si no lo encuentra, asegúrese de revisar también su carpeta de spam o correo no deseado. Tenga en cuenta que el correo puede tardar hasta 5 minutos en llegar.   ",
            label_button: "Volver al login"
        },
        acount_successful: {
            title: "Tu cuenta ha sido creada",
            description1: "Hemos enviado un correo a ",
            description2: "para que continúes con el proceso y puedas hacer uso de todos nuestros servicios. Tenga en cuenta que el correo puede tardar hasta 5 minutos en llegar.",
        },
        otp_email: {

        },
        type_user: {
            title: "Seleccione el tipo de usuario que desea crear",
            button_user: "Persona",
            button_businnes: "Empresa",
            label_acount: "Ya tengo cuenta Colurs",
            terminos_condiciones: "Términos y condiciones",
            label_button: "Continuar"
        },
        registre_person: {
            title: "Ingresa los siguientes datos para crear tu cuenta",
            label_firts_name: "Nombre(s)",
            placeholder_firts_name: "Ingresa tu nombre",
            label_last_name: "Apellidos",
            placeholder_last_name: "Ingresa tu apellido",
            label_pais: "País de residencia",
            label_email: "Email",
            placeholder_email: "correo@ejemplo.com",
            label_phone: "Número de teléfono",
            placeholder_phone: "(300) 123-4567",
            label_password: "Contraseña",
            placeholder_password: "Crea una contraseña segura",
            subtitle_password: "Mínimo 8 caracteres",
            label_back: "Volver",
            label_continue: "Crear cuenta",
            label_acount: "Ya tengo cuenta Colurs",
            terminos_condiciones: "Términos y condiciones",
            error_email: "Por favor ingrese un correo electrónico válido."
        },
        registre_company: {
            title: "Ingresa los siguientes datos para crear tu cuenta",
            label_firts_name: "Nombre(s)",
            placeholder_firts_name: "Ingresa tu nombre",
            label_last_name: "Apellidos",
            placeholder_last_name: "Ingresa tu apellido",
            label_pais: "País de residencia",
            label_email: "Email",
            placeholder_email: "correo@ejemplo.com",
            label_phone: "Número de teléfono",
            placeholder_phone: "(300) 123-4567",
            label_password: "Contraseña",
            placeholder_password: "Crea una contraseña segura",
            subtitle_password: "Mínimo 8 caracteres",
            label_back: "Volver",
            label_continue: "Crear cuenta",
            label_acount: "Ya tengo cuenta Colurs",
            terminos_condiciones: "Términos y condiciones",
            label_terminos_condiciones: "Al hacer clic en 'Siguiente', estoy de acuerdo con los términos y condiciones de uso de Colurs.",
            error_email: "Por favor ingrese un correo electrónico válido.",
            "contry_onboarding": "¿En qué país está establecida su empresa?",
            error_phone: 'Ya hay un usuario registrado con este teléfono'
        },
        welcome: {
            saludo: "Hola ",
            title: ", bienvenido a tu cuenta Colurs",
            subtitle: "Queremos conocerte más a fondo. Cuéntanos un poco sobre ti y tu empresa. Completar el formulario te tomará alrededor de 10 minutos. ",
            label_button: "Empecemos"
        },
        name_businnes: {
            title: "¿Cómo se llama tu empresa?",
            subtitle: "Introduce un nombre como quieres que aparezca en tu usuario Colurs. No es necesario que sea el nombre legal de tu empresa. Éste lo puedes ingresar más adelante. ",
            label_empresa: "Nombre empresa",
            placeholder_empresa: "Ej. Adidas, Nike",
            label_button: "Continuar",
            posdata: "By clicking 'Next,' I confirm that I am authorized to accept this agreement on behalf of the business.",
            error_name_company: "Debe ingresa el nombre de su empresa"
        },
        service_colurs: {
            title: "¿Cuáles de los siguientes servicios de Colurs estás interesado en usar?",
            description: "Puedes seleccionar múltiples opciones. Esto nos ayudará a brindarte una experiencia personalizada.",
            service1: "Transferencias Internacionales",
            service2: "Pagos Globales",
            service3: "Intercambio de Divisas",
            service4: "Recaudo Internacional",
            service5: "Payroll",
            service6: "Monetización",
            error_service_colurs: "Debes seleccionar al menos una opción.",
            label_button: "Continuar"
        },
        activity_company: {
            title: "¿Tu empresa realiza alguna de las siguientes actividades?",
            description: "Puedes seleccionar múltiples opciones.",
            activity1: "Ganadería",
            activity2: "Minería y Extracción",
            activity3: "Entretenimiento y Juegos de Azar",
            activity4: "Comercio de Bienes de Lujo y Real Estate",
            activity5: "Producción de Contenidos y Cursos Online",
            activity6: "Ninguna de los anteriores",
            label_button: "Continuar",
            error_activity: "Debes seleccionar al menos una opción."
        },
        benefactor: {
            title: "Beneficiario",
            natural_person: "Persona natural",
            artificial_person: "Persona Jurídica",
            natural_person_name: "Nombre",
            natural_person_name_placeholder: "Juan",
            natural_person_last_name: "Apellido",
            natural_person_last_name_placeholder: "Perez",
            artificial_person_name_company: "Nombre de la empresa",
            artificial_person_name_company_placeholder: "Empresa S.A.",
            artificial_person_identification_company: "Identificación de la empresa",
            artificial_person_identification_company_placeholder: "1234567890",
            porcentaje_benefactor: "Porcentaje de participación",
            porcentaje_benefactor_paceholder: "50%",
            country: "País",
            label_pep: "Es persona expuesta públicamente (PEP)"
        },
        navbar: {
            title: "¿Estás seguro que deseas salir?",
            description: "Todos los datos suministrados en la actual página se perderán. Asegúrate de presionar 'Sí, salir' si deseas guardar los cambios.",
            label_button_back: "Cancelar",
            label_button_next: "Sí, salir",
            label_hover: "Salir"
        },

        steps: {
            titles: [
                "Información de la empresa",
                "Sector económico",
                "Información administrativa",
                "Beneficiarios finales",
                "Declaración y autorización",
                "Documentos para estudios",
                "Resumen",
            ],
            label_current_step: "Paso",
        },
        "modal_alert_back": {
            title: "Estás seguro que deseas volver?",
            description: "Si vuelve todos sus cambios en el paso actual se perderan",
            label_button_back: "Cancelar",
            label_button_next: "Si, volver"
        },
        "modal_alert": {
            title: "¿Estás seguro que deseas volver?",
            description: "Si vuelves, todos tus cambios en el paso actual se perderán.",
            label_button_white: "Sí, volver"
        },
        "modal_alert_kyc": {
            "title": "¡Es necesario completar el KYC del representante legal!",
            "description": "Para continuar con el proceso, el representante legal debe completar el formulario de KYC. Este paso es obligatorio para validar la información y permitir el envío de toda la documentación.",
            "label_button_next": "Entiendo"
        },
        "modal_alert_shelholder": {
            "title": "¡Es necesario enviar los KYC de los beneficiarios!",
            "description": "Para completar el proceso y enviar toda la documentación, asegúrate de enviar los KYC de los beneficiarios. Sin esta información, no podremos proceder con el envío de la documentación.",
            "label_button_next": "Entiendo"
        },
        modal_alert_pdf_large: {
            title: "Archivo demasiado grande",
            description: "El archivo que intentaste subir excede el tamaño permitido. Por favor, selecciona un archivo más pequeño e inténtalo nuevamente.",

        },
        modal_alert_pdf_error: {
            title: "Error al subir el archivo",
            description: "Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo."
        },
        splash_doc: {
            title: "Creando perfil personalizado"
        },
        steps1: {
            title: "Información de la empresa",
            label_name_legal_company: "Nombre legal de la empresa",
            name_legal_company_placeholder: "Nombre de la compañía",
            sector_company: "Mi compañía pertenece al sector privado",
            identification_company: "Identificación de la compañía",
            identification_company_placeholder: "123456789-0",
            company_create_date: "Fecha de creación de la empresa",
            contry_registered: "País donde se registró",
            label_state: "Estado",
            state_placeholder: "Nombre Estado",
            label_city: "Ciudad",
            city_placeholder: "Nombre Ciudad",
            address: "Dirección",
            address_placeholder: "Indique dirección empresa",
            phone_number: "Número de teléfono",
            phone_number_placeholder: "(300) 123-4567",
            label_website: "Página web de tu empresa",
            website_placeholder: "miempresa.com",
            company_description: "Descripción de tu empresa",
            company_description_placeholder: 'Ejemplo: En Colurs, nos comprometemos a construir una red global que unifique lo mejor de dos mundos: la seguridad y transparencia de la blockchain y la estabilidad del sistema bancario tradicional.',
            label_button: "Continuar"
        },
        steps2: {
            title: "Sector económico",
            label_activity_economic: "Actividad económica",
            description_activity_economic: "Descripción detallada de la actividad económica",
            activity_economic_placeholder: 'Ejemplo: En Colurs, nos comprometemos a construir una red global que unifique lo mejor de dos mundos: la seguridad y transparencia de la blockchain y la estabilidad del sistema bancario tradicional.',
            min_caracters: 'Mínimo 150 carácteres',
            monthly_income: "Ingresos mensuales (USD)",
            monthly_expenses: "Egresos mensuales (USD)",
            total_assets: "Total activos (USD)",
            total_liabilities: "Total pasivos (USD)",
            total_equity: "Patrimonio total (USD)",
            country_taxes: "País donde declara impuestos",
            other_income: "¿Posee otros ingresos?",
            other_income_description: "Concepto de otros ingresos",
            other_monthly_income: "Ingresos mensuales (USD)",
            investments_or_operations_abroad: "¿Realiza operaciones en moneda internacional o tiene inversiones en el extranjero?",
            contry_abroad: "País",
            num_product_abroad: "Número del producto",
            name_entity_abroa: "Entidad",
            value_transaction: "Valor transacciones (USD)",
            policy_aml: "Poseo una política AML",
            compliance_officer: "Poseo un oficial de cumplimiento",
            license_required: "Mi actividad requiere licencia",
            label_license_required: "Subir licencia",
            trade_with_virtual_assets: "Realizo operaciones en activos virtuales",
            label_button_back: "Volver",
            label_button_next: "Continuar"
        },

        steps3: {

            title: "Información directores y administradores",
            name_legal_representative: "Nombre(s) del representante legal",
            name_legal_representative_placeholder: 'John Alexander',
            last_name_legal_representative: "Apellidos del representante legal",
            last_name_legal_representative_placeholder: "Smith",
            num_identification: "Número de pasaporte",
            num_identification_placeholder: 'AB123456',
            country_of_domicile: "País de domicilio",
            state_of_domicile: "Estado domicilio",
            state_of_domicile_placeholder: "Escriba el Estado",
            city_of_domicile: "Ciudad domicilio",
            city_of_domicile_placeholder: "Escriba la Ciudad",
            address_of_domicile: "Dirección domicilio",
            address_of_domicile_placeholder: 'Calle 100 51B-77',
            address_details: "Detalles del domicilio",
            address_details_placeholder: 'Edificio, conjunto, torre, apartamento',
            phone: "Teléfono",
            phone_placeholder: '(300) 123-4567',
            email: "Correo",
            email_placeholder: 'ejemplo@correo.com',
            share_link: 'Compartir link',
            title_verify: "Verifica tu identidad",
            description_verify: "Puedes validar tu propia identidad o compartir un link para que alguien en tu equipo lo haga por ti.",
            politically_exposed_person: "Soy una persona expuesta políticamente (PEP)",
            politically_exposed_person_carge: "Cargo",
            politically_exposed_person_description: "Descripción detallada de la actividad económica",
            manage_public_resources: "Administras recursos públicos",
            label_button_back: "Volver",
            label_button_next: "Continuar",
            placeholder_public: "Indica el cargo",
            placeholder_detail: "Ejemplo: En Colurs, nos comprometemos a construir una red global que unifique lo mejor de dos mundos: la seguridad y transparencia de la blockchain y la estabilidad del sistema bancario tradicional.",
            placeholder_state: "Escriba el Estado"
        },

        steps4: {
            title: "Información de beneficiarios finales",
            subtitle: "Indique los accionistas con participación igual o superior al 5% de las acciones de la sociedad.",
            doctitle1: "Certificación de accionista",
            doctitle2: "Identificación del accionista",
            button_save: "Guardar beneficiario",
            add: "Añadir beneficiario",
            button_back: "Volver",
            button_next: "Continuar"
        },
        steps5: {
            title: "Declaración de origen de fondos",
            description: "Declaro que: los recursos que manejo o mis recursos propios y activos provienen de las siguientes fuentes:",
            placeholder_description: 'Especifica a fondo la ocupación, oficio, profesión, actividad, negocio, entre otras fuentes de ingresos. No utilizar profesiones genéricas, por ejemplo: comerciante',
            other_income: "Tengo ingresos adicionales",
            other_income_description: "Especifique su origen",
            label_checkbox: 'Acepto los términos y condiciones',
            label_see_more: "Ver más",
            label_see_less: "Ver menos",
            placeholder_other_income_description: 'Utiliza este espacio para detallar a fondo de donde obtiene sus ingresos adicionales.',
            terms_and_conditions: "Para los efectos de esta autorización, se entiende por 'LA COMPAÑÍA' a COLURS, y/o cualquier sociedad controlada, directa o indirectamente, por la misma matriz. declaro expresamente: 1. Finalidad para el Suministro de Datos Personales: Proporciono mis datos personales a COLURS para todos los fines precontractuales y contractuales necesarios para acceder a sus servicios. 2. Información explícita de LA COMPAÑÍA: Finalidades del Tratamiento de Datos Personales: Mis datos personales serán utilizados para: i. Tramitar mi solicitud como cliente, empleado, contratista, contraparte contractual y/o proveedor. ii. Procesos de negociación de contratos. iii. Ejecución y cumplimiento de contratos. iv. Prevención y control del fraude. v. Liquidación y pago de comisiones o cualquier otra transacción monetaria acordada. vi. Gestión integral de los servicios contratados. vii. Cumplimiento de requisitos para acceso a sistemas integrales de seguridad social. viii. Creación de estudios técnicos, actuariales, económicos, encuestas de mercado y análisis de tendencias. ix. Distribución de información relacionada con políticas anti-fraude, encuestas de satisfacción de clientes y ofertas comerciales de productos y servicios. x. Realización de encuestas sobre la satisfacción del servicio. xi. Información financiera de personas sujetas a tributación en Estados Unidos al IRS bajo el Foreign Account Tax Compliance Act (FATCA). xii. Intercambio de información tributaria bajo tratados y acuerdos internacionales. xiii. Prevención y control del lavado de activos y financiación del terrorismo. 3. Ejecución del Tratamiento: El tratamiento puede ser realizado directamente por COLURS o por procesadores designados como necesarios. 4. Usuarios de la Información: Los datos pueden ser compartidos con: - Entidades dentro del grupo corporativo de LA COMPAÑÍA. - Proveedores de servicios esenciales para el cumplimiento de obligaciones contractuales (como centros de llamadas, investigadores, compañías de asistencia, abogados externos). - Agentes comerciales involucrados en el ciclo de vida del contrato. - Entidades de evaluación de riesgos, entidades reguladoras y supervisoras, y entidades de gestión de datos para la prevención de fraudes y cumplimiento de normativas de seguridad social. 5. Transferencia Internacional de Datos: En ciertos casos, puede ser necesaria la transferencia internacional de datos para alcanzar estos fines. 6. Datos Sensibles: Las respuestas a preguntas sobre datos sensibles, como datos de salud o biométricos, son voluntarias. Autorizo expresamente el tratamiento de dichos datos sensibles. 7. Derechos del Titular de los Datos: Como titular de los datos, tengo derechos conforme a las leyes aplicables, incluyendo el derecho de acceder, actualizar y rectificar mi información personal. 8. Responsables del Tratamiento de la Información: El responsable del tratamiento de los datos es COLURS, según su política de privacidad y tratamiento de datos personales, disponible en su sitio web. Autorización: Autorizo expresamente el tratamiento de mis datos personales, incluidos los datos sensibles, y si es necesario, la transferencia internacional de estos datos, por las partes y para los fines indicados. Información de la Política: He sido debidamente informado sobre la política de privacidad y tratamiento de datos personales de LA COMPAÑÍA, consultable en:",
            label_button_back: "Volver",
            label_button_next: "Continuar",
        },
        steps6: {
            title: "Documentos para estudio",
            label_button_back: "Volver",
            label_button_next: "Continuar",
            error_label: "Debe Completar todos los campos para poder continuar"

        },
        steps7: {
            title: "Parece que todo está listo para solicitar tu cuenta Colurs",
            description: "No está de más asegurarse que toda la información esté completa. Da clic sobre alguna de estas opciones en caso que quieras revisar y/o actualizar algún documento. Si todo está perfecto, continúa con el proceso y da clic en el botón 'Enviar Solicitud'.",
            label_button1: 'Información de la empresa',
            label_button2: 'Sector económico',
            label_button3: 'Información administrativa',
            label_button4: 'Beneficiarios finales',
            label_button5: 'Declaración y autorización',
            label_button6: 'Documentos para estudios',
            label_button7: 'Falta el KYC del representante legal.',
            label_button8: 'Falta el KYC de los beneficiarios.',
            label_button_back: "Volver",
            label_button_next: "Enviar solicitud",

        },
        documentation_complete: {
            title: "Tu solicitud ha sido enviada con éxito",
            description: "La documentación ha sido recibida. En pocos días recibirás información por parte de nuestro equipo.",
            label1: "Si tienes dudas o preguntas, no ",
            label_subrayado: "dudes en contactar a nuestro equipo."
        },
        banned: {
            title: "Tu solicitud ha sido enviada con éxito",
            description: "La documentación ha sido recibida. En pocos días recibirás información por parte de nuestro equipo.",
            label1: "Si tienes dudas o preguntas, no ",
            label_subrayado: "dudes en contactar a nuestro equipo."
        },
        rejected: {
            error_validation_document: "Debes subir todos los archivos",
            error_loading_document: "Ocurrió un error al subir los archivos",
            file_too_large: "Archivo demasiado grande",
            error_document_upload: "no se pudo subir el archivo",
            title: "Documentos para estudio",
            subtitle: "Rechazado por:",
            error_validation_final: "Debe Completar todos los campos para poder continuar",
            title_modal: "Subida de archivos exitosa",
            subtitle_modal: "Todos los archivos se subieron exitosamente.",
            button_label: "Listo",
            label_shareholder: "Benefactor: "


        },
        register_validation: {
            validation_phone: 'Introduzca un número válido',
            validation_password: 'La contrasena debe tener minimo 8 caracteres',
            validation_email_repeated: `Ya hay una cuenta resgistrada con este correo:`,
            validation_phone_repeated: `Ya hay una cuenta resgistrada con este celular:`,

            validation_unexpected: "Ocurrió un error al registrar la cuenta. Inténtelo de nuevo.",
            validation_existing_user: "Esta cuenta ya está registrada. Por favor, inicie sesión o use otro correo electrónico.",

        },

        status_verification: {
            pending: {
                title: 'Verificación pendiente',
                description: 'Estamos analizando los datos suministrados. En pocos segundos te notificaremos el resultado del proceso.',
            },
            failed: {
                title: 'Verificación fallida',
                description: 'Algo salió mal mientras verificábamos tu identidad. Puedes intentar nuevamente. Asegúrate de tener todos tus documentos e información a la mano.',
            },
            verified: {
                title: 'Usuario verificado',
                description: '',
            },
            unknown: {
                title: 'Estado desconocido',
                description: 'La funcion actual no está habilitada.',
            },
        },
        validation: {
            incomplete_data: 'Debe Completar todos los campos para poder continuar'
        },
        documents: {
            arhivo_sociedad: "Acta de constitución de la sociedad",
            arhivo_tributario: "Certificado de registro tributario",
            arhivo_mercantil: "Documento de registro mercantil",
            arhivo_brochure: "Brochure de la compañía",
            financial_statements: "Estados financieros del último año",
            legal_representative_passport: "Copia pasaporte representante legal",
            statement_origin_fund: "Declaración de origen de fondos firmada por el contador y el revisor fiscal",
            good_conduct_certificate: "Certificado de Antecedentes Judiciales",
            proof_of_address: "Evidencia domicilio de la sociedad (contrato de arrendamiento, factura de servicios públicos que acredite el domicilio de la sociedad",
            shareholder_certification: "Certificado de accionistas con más del 5% de participación firmado por el contador o revisor fiscal",
            document_ID_shareholder: "Identificación de los accionistas con participación del más del 5%",
            doccounter_background_check: "Certificado de antecedentes del contador o revisor fiscal emitido por la junta central de contadores",
            professional_accountant_license: "Copia de la tarjeta profesional del contador o revisor fiscal",

        }
    },

    en: {
        "banner_login": {
            "p1": "Your company moves",
            "p2": "forward, with Colurs you",
            "p3": "make the difference.",
        },
        "login": {
            "title": "Use your email to sign in",
            "label_email": "Email Address",
            "placeholder_email": "email@example.com",
            "placeholder_password": "Enter your password",
            "label_password": "Password",
            "button_login": "Sign In",
            "buton_register": "Create new account",
            "tyc": "Terms and Conditions",
            "request_password": "Reset password",
            "label_button_login": "Log In",
            "error_message": "The combination of credentials does not have an active account"
        },
        upload_pdf: {
            alert_pdf: "Please select a PDF file with a maximum size of 15 MB.",
            title: "Drag your file here or upload it from your PC by clicking",
            click: "click here",
            subtitle: "PDF format (max. 15.0 MB)",
            change_file: "Change file",
            read_only: "Uploaded file"
        },
        "register": {
            "title": "Scan the QR code"
        },
        "two_factor": {
            "title": "Enter the security code",
            "description": "Enter the one-time code that appears in your authentication app: "
        },
        "request_password": {
            "title": "Recover Password",
            "subtitle": "Enter the email with which you registered your Colurs account. You will soon receive a new password: ",
            "label_email": "Email Address",
            "button_confirm": "Request New Password",
            "button_back": "Go Back",
            "placeholder_email": "youremail@gmail.com",
            "error_message": "You must enter a valid email address"
        },
        "success_recovery": {
            "title": "Password recovery email sent",
            "description": "We have sent an email to the address registered with your account with instructions to reset your password. Please check your inbox, and if you don't find it, also check your spam or junk folder. Please note that the email may take up to 5 minutes to arrive.",
            "label_button": "Back to Login"
        },
        "acount_successful": {
            "title": "Your account has been created",
            "description1": "We have sent an email to ",
            "description2": "so you can continue the process and use all our services. Please note that the email may take up to 5 minutes to arrive."
        },
        "otp_email": {},
        "type_user": {
            "title": "Select the type of user you want to create",
            "button_user": "Individual",
            "button_businnes": "Business",
            "label_acount": "I already have a Colurs account",
            "terminos_condiciones": "Terms and Conditions",
            "label_button": "Continue"
        },
        "registre_person": {
            "title": "Enter the following details to create your account",
            "label_firts_name": "First Name",
            "placeholder_firts_name": "Enter your first name",
            "label_last_name": "Last Name",
            "placeholder_last_name": "Enter your last name",
            "label_pais": "Country of Residence",
            "label_email": "Email",
            "placeholder_email": "email@example.com",
            "label_phone": "Phone Number",
            "placeholder_phone": "(300) 123-4567",
            "label_password": "Password",
            "placeholder_password": "Create a secure password",
            "subtitle_password": "Minimum 8 characters",
            "label_back": "Go Back",
            "label_continue": "Create Account",
            "label_acount": "I already have a Colurs account",
            "terminos_condiciones": "Terms and Conditions",
            "error_email": "Please enter a valid email address."
        },
        inputselect_search: {
            placeholder: "Select an option",
            search_placeholder: "Search..."
        },
        input_date: {
            placeholder: "Select year, month, and day"
        },


        "registre_company": {
            "title": "Enter the following details to create your account",
            "label_firts_name": "First Name",
            "placeholder_firts_name": "Enter your first name",
            "label_last_name": "Last Name",
            "placeholder_last_name": "Enter your last name",
            "label_pais": "Country of Residence",
            "label_email": "Email",
            "placeholder_email": "email@example.com",
            "label_phone": "Phone Number",
            "placeholder_phone": "(300) 123-4567",
            "label_password": "Password",
            "placeholder_password": "Create a secure password",
            "subtitle_password": "Minimum 8 characters",
            "label_back": "Go Back",
            "label_continue": "Create Account",
            "label_acount": "I already have a Colurs account",
            "terminos_condiciones": "Terms and Conditions",
            "label_terminos_condiciones": "By clicking 'Next', I agree to the Colurs terms and conditions of use.",
            "error_email": "Please enter a valid email address.",
            "contry_onboarding": " Which country is your company established in?",
            error_phone: 'There is already a registered user with this phone'
        },
        "welcome": {
            "saludo": "Hello ",
            "title": ", welcome to your Colurs account",
            "subtitle": "We want to get to know you better. Tell us a little about you and your company. Completing the form will take about 10 minutes.",
            "label_button": "Let's get started"
        },
        "name_businnes": {
            "title": "What's your business called?",
            "subtitle": "Enter a name as you'd like it to appear on your Colurs account. It doesn't have to be your business's legal name—you can provide that later.",
            "label_empresa": "Business Name",
            "placeholder_empresa": "e.g. Adidas, Nike",
            "label_button": "Next",
            "posdata": "By clicking 'Next,' I confirm that I am authorized to accept this agreement on behalf of the business.",
            "error_name_company": "You must enter your company name"
        },
        "service_colurs": {
            "title": "Services of Interest",
            "description": "Select the Colurs services you are interested in using. You can select multiple options:",
            "service1": "International Transfers",
            "service2": "Global Payments",
            "service3": "Currency Exchange",
            "service4": "International Collections",
            "service5": "Payroll",
            "service6": " FX/IMC Market",
            "error_service_colurs": "You must select at least one option.",
            "label_button": "Next"
        },
        "activity_company": {
            "title": "Business Activities",
            "description": "Does your company engage in any of the following activities? You can select multiple options:",
            "activity1": "Livestock and Agriculture",
            "activity2": "Mining and Resource Extraction",
            "activity3": "Entertainment and Gambling",
            "activity4": "Luxury Goods Trade and Real Estate Development",
            "activity5": "Online Content and Education Services",
            "activity6": "None of the above",
            "label_button": "Next",
            "error_activity": "You must select at least one option."
        },
        "benefactor": {
            "title": "Beneficiary",
            "natural_person": "Natural Person",
            "artificial_person": "Legal Entity",
            "natural_person_name": "First Name",
            "natural_person_name_placeholder": "John",
            "natural_person_last_name": "Last Name",
            "natural_person_last_name_placeholder": "Doe",
            "artificial_person_name_company": "Company Name",
            "artificial_person_name_company_placeholder": "Company Ltd.",
            "artificial_person_identification_company": "Company ID",
            "artificial_person_identification_company_placeholder": "1234567890",
            "porcentaje_benefactor": "Ownership Percentage",
            "porcentaje_benefactor_paceholder": "50%",
            "country": "Country",
            "label_pep": "Is a Politically Exposed Person (PEP)"
        },
        "navbar": {
            "title": "Are you sure you want to log out?",
            "description": "All data entered on the current page will be lost. Make sure to click 'Yes, log out' if you want to save your changes.",
            "label_button_back": "Cancel",
            "label_button_next": "Yes, log out",
            "label_hover": "Log out"
        },
        "modal_alert": {
            title: "Are you sure you want to go back?",
            description: "If you go back, all your changes on the current step will be lost.",
            label_button_white: "Yes, go back"
        },
        "steps": {
            "titles": [
                "Company Information",
                "Economic Sector",
                "Directors and Administrators",
                "Ultimate Beneficial Owners",
                "Source of Funds Declaration",
                "Documents for Review",
                "Final Submission"
            ],
            "label_current_step": "Step"
        },

        "modal_alert_back": {
            title: "Are you sure you want to go back?",
            "description": "If you go back, all your changes in the current step will be lost.",
            "label_button_back": "Cancel",
            "label_button_next": "Yes, go back"
        },
        "modal_alert_kyc": {
            "title": "It is necessary to complete the legal representative's KYC!",
            "description": "To proceed with the process, the legal representative must complete the KYC form. This step is mandatory to validate the information and allow the submission of all documentation.",
            "label_button_next": "I understand"
        },
        "modal_alert_shelholder": {
            "title": "It is necessary to submit the shareholders' KYC!",
            "description": "To complete the process and submit all documentation, make sure to send the shareholders' KYC. Without this information, we cannot proceed with the submission of the documentation.",
            "label_button_next": "I understand"

        },
        "modal_alert_pdf_large": {
            "title": "File Too Large",
            "description": "The file you tried to upload exceeds the allowed size. Please select a smaller file and try again."
        },
        "modal_alert_pdf_error": {
            "title": "File Upload Error",
            "description": "There was an issue while trying to upload the file. Please check the details and try again."
        },
        splash_doc: {
            title: "Creating custom profile"
        },
        "steps1": {
            "title": "Company Information",
            "label_name_legal_company": "Legal Name",
            "name_legal_company_placeholder": "Name of the Company LLC",
            "sector_company": "Private sector",
            "identification_company": "EIN",
            "identification_company_placeholder": "12-3456789",
            "company_create_date": "Date of Incorporation",
            "contry_registered": "Country of Registration",
            "label_state": "State",
            "state_placeholder": "Input State",
            "label_city": "City",
            "city_placeholder": "Input City",
            "address": "Address",
            "address_placeholder": "Input Address",
            "phone_number": "Phone Number",
            "phone_number_placeholder": "(300) 123-4567",
            "label_website": "Company Website",
            "website_placeholder": "E.g. mycompany.com",
            "company_description": "Company Description",
            "company_description_placeholder": "E.g. At Colurs, we're dedicated to creating a global network that seamlessly blends the security and transparency of blockchain technology with the reliability of traditional banking systems.",
            "label_button": "Next",
        },
        "steps2": {
            "title": "Economic Sector",
            "description": "Provide details about your company's economic sector, including:",
            "label_activity_economic": "NAICS/SIC Code",
            "description_activity_economic": "Detailed description of economic activity",
            "activity_economic_placeholder": "Example: At Colurs, we are committed to building a global network that unites the best of two worlds: the security and transparency of blockchain and the stability of the traditional banking system.",
            "min_caracters": "Minimum 150 characters",
            "monthly_income": "Monthly Revenue (USD)",
            "monthly_expenses": "Monthly Expenses (USD)",
            "total_assets": "Total Assets (USD)",
            "total_liabilities": "Total Liabilities (USD)",
            "total_equity": "Total Equity (USD)",
            "country_taxes": "Country of Tax Filing",
            "other_income": "Do you have other income?",
            "other_income_description": "Other income source",
            "other_monthly_income": "Monthly Income (USD)",
            "investments_or_operations_abroad": "Do you conduct operations in foreign currency or have investments abroad?",
            "contry_abroad": "Country",
            "num_product_abroad": "Product number",
            "name_entity_abroad": "Entity",
            "value_transaction": "Transaction Value (USD)",
            "policy_aml": "I have an AML policy",
            "compliance_officer": "I have a compliance officer",
            "license_required": "My activity requires a license",
            "label_license_required": "Upload License",
            "trade_with_virtual_assets": "I conduct operations with virtual assets",
            "label_button_back": "Back",
            "label_button_next": "Next"
        },
        "steps3": {
            "title": "Directors and Administrators",
            "name_legal_representative": "First Name(s)",
            "name_legal_representative_placeholder": "John Alexander",
            "last_name_legal_representative": "Last Name",
            "last_name_legal_representative_placeholder": "Smith",
            "num_identification": "Passport Number or SSN",
            "num_identification_placeholder": "AB123456",
            "country_of_domicile": "Country",
            "state_of_domicile": "State",
            "state_of_domicile_placeholder": "Input State",
            "city_of_domicile": "City of Domicile",
            "city_of_domicile_placeholder": "Input City",
            "address_of_domicile": "Full Address",
            "address_of_domicile_placeholder": "E.g. Orlando, FL 32819-8123",
            "address_details": "Address Details",
            "address_details_placeholder": "Building, complex, tower, apartment",
            "phone": "Phone number",
            "phone_placeholder": "(300) 123-4567",
            "email": "Emai Address",
            "email_placeholder": "example@email.com",
            "share_link": "Share link",
            "title_verify": "Verify Your Identity",
            "description_verify": "You can validate your own identity or share a link for someone on your team to do it for you.",
            "politically_exposed_person": "I am a Politically Exposed Person (PEP)",
            "politically_exposed_person_carge": "Position",
            "politically_exposed_person_description": "Detailed description of economic activity",
            "manage_public_resources": "Do you manage public resources?",
            "label_button_back": "Back",
            "label_button_next": "Next",
            placeholder_public: "Indicate the position",
            placeholder_detail: "Example: At Colurs, we are committed to building a global network that unifies the best of both worlds: the security and transparency of blockchain and the stability of the traditional banking system.",
            placeholder_state: "Write the State"
        },
        "steps4": {
            title: "Ultimate Beneficial Owners",
            subtitle: "List shareholders with an ownership stake of 5% or more:.",
            doctitle1: "Government-issued ID",
            doctitle2: "Shareholder Certification or Proof of Ownership",
            button_save: "Save beneficiary",
            add: "Add beneficiary",
            button_back: "back",
            button_next: "next"
        },

        "steps5": {
            "title": "Source of Funds Declaration",
            "description": "Declare the source of funds used in your operations.",
            "placeholder_description": "E.g. 'The funds are derived from legitimate business activities, including revenue generated from global payments and financial services.'",
            "other_income": "I have additional income",
            "other_income_description": "Specify the source",
            "label_checkbox": "I accept the terms and conditions",
            "label_see_more": "See more",
            "label_see_less": "See less",
            "label_button_back": "Back",
            "label_button_next": "Next",
            "placeholder_other_income_description": "Use this space to explain where you get your additional income.",
            "terms_and_conditions": "For the purposes of this authorization, 'THE COMPANY' refers to COLURS, and/or any company controlled, directly or indirectly, by the same parent company. I expressly declare: 1. Purpose for the Supply of Personal Data: I provide my personal data to COLURS for all pre-contractual and contractual purposes necessary to access its services. 2. Explicit Information about THE COMPANY: Purposes for Personal Data Processing: My personal data will be used for: i. Processing my request as a client, employee, contractor, contractual counterpart, and/or supplier. ii. Contract negotiation processes. iii. Execution and compliance with contracts. iv. Fraud prevention and control. v. Settlement and payment of commissions or any other agreed monetary transaction. vi. Comprehensive management of contracted services. vii. Compliance with requirements for access to comprehensive social security systems. viii. Creation of technical, actuarial, economic studies, market surveys, and trend analysis. ix. Distribution of information related to anti-fraud policies, customer satisfaction surveys, and commercial product and service offers. x. Conducting service satisfaction surveys. xi. Financial information for persons subject to taxation in the United States to the IRS under the Foreign Account Tax Compliance Act (FATCA). xii. Exchange of tax information under international treaties and agreements. xiii. Prevention and control of money laundering and terrorist financing. 3. Execution of the Processing: The processing may be carried out directly by COLURS or by designated processors as necessary. 4. Information Users: The data may be shared with: - Entities within THE COMPANY's corporate group. - Service providers essential to fulfilling contractual obligations (such as call centers, investigators, assistance companies, external lawyers). - Commercial agents involved in the contract lifecycle. - Risk evaluation entities, regulatory and supervisory entities, and data management entities for fraud prevention and social security compliance. 5. International Data Transfer: In certain cases, international data transfer may be necessary to achieve these purposes. 6. Sensitive Data: Answers to questions about sensitive data, such as health or biometric data, are voluntary. I expressly authorize the processing of such sensitive data. 7. Rights of the Data Subject: As the data subject, I have rights under applicable laws, including the right to access, update, and rectify my personal information. 8. Data Processing Responsibilities: The data processing responsibility lies with COLURS, according to its privacy and personal data processing policy, available on its website. Authorization: I expressly authorize the processing of my personal data, including sensitive data, and if necessary, the international transfer of such data, by the parties and for the purposes indicated. Policy Information: I have been duly informed about THE COMPANY's privacy and personal data processing policy, available for consultation at:"
        },
        "steps6": {
            "title": "Documents for Study",
            "description": "Upload additional documents for compliance review:",
            "label_button_back": "Back",
            "label_button_next": "Continue",
            "error_label": "You must complete all fields to continue"
        },
        "steps7": {
            "title": "Final Submission",
            "description": "Review all the provided information and ensure it is complete. If everything is correct, click 'Submit Application' to finalize your request.",
            "label_button1": "Company Information",
            "label_button2": "Economic Sector",
            "label_button3": "Directors and Administrators",
            "label_button4": "Ultimate Beneficial Owners",
            "label_button5": "Source of Funds Declaration",
            "label_button6": "Documents for Review",
            "label_button7": "Missing KYC of legal representative.",
            "label_button8": "Missing KYC of beneficiaries.",
            "label_button_back": "Back",
            "label_button_next": "Submit Application"
        },
        "documentation_complete": {
            "title": "Your request has been successfully submitted",
            "description": "The documentation has been received. You will receive information from our team in a few days.",
            "label1": "If you have any questions, please don't ",
            "label_subrayado": "hesitate to contact our team."
        },
        "banned": {
            "title": "Your request has been successfully submitted",
            "description": "The documentation has been received. You will receive information from our team in a few days.",
            "label1": "If you have any questions, please don't ",
            "label_subrayado": "hesitate to contact our team."
        },

        rejected: {
            error_validation_document: "You must upload all the files",
            error_loading_document: "An error occurred while uploading the files",
            file_too_large: "File too large",
            error_document_upload: "The file could not be uploaded",
            title: "Documents for study",
            subtitle: "Rejected due to:",
            error_validation_final: "You must complete all fields to proceed",
            title_modal: "Successful file upload",
            subtitle_modal: "All files were uploaded successfully.",
            button_label: "Ok",
            label_shareholder: "Shareholder: "

        },
        "register_validation": {
            "validation_phone": "Please enter a valid phone number",
            "validation_password": "The password must have at least 8 characters",
            "validation_email_repeated": "An account is already registered with this email:",
            validation_phone_repeated: `There is already an account registered with this phone number:`,
            "validation_unexpected": "An error occurred while registering the account. Please try again.",
            "validation_existing_user": "This account is already registered. Please log in or use another email."
        },
        "status_verification": {
            "pending": {
                "title": "Verification Pending",
                "description": "We are analyzing the provided data. We will notify you of the process result in a few seconds."
            },
            "failed": {
                "title": "Verification Failed",
                "description": "Something went wrong while verifying your identity. You can try again. Make sure you have all your documents and information ready."
            },
            "verified": {
                "title": "User Verified",
                "description": ""
            },
            "unknown": {
                "title": "Unknown Status",
                "description": "The current feature is not enabled."
            }
        },
        "validation": {
            "incomplete_data": "You must complete all fields to proceed"
        },
        "documents": {
            "arhivo_sociedad": "Articles of Incorporation or Corporate Formation Document",
            "arhivo_tributario": "EIN Confirmation Letter",
            "arhivo_mercantil": "Operating Agreement or Bylaws (if applicable)",
            "arhivo_brochure": "Company Brochure",
            "financial_statements": "Upload financial statements from the last fiscal year",
            "legal_representative_passport": "Director's passport or government-issued ID",
            "statement_origin_fund": "Statement of Source of Funds signed by the accountant and auditor",
            "good_conduct_certificate": "Certificate of Good Standing",
            "proof_of_address": "Proof of Address (E.g. Utility bill or lease agreement)",


            "document_ID_shareholder": "Government-issued ID",
            "shareholder_certification": "Shareholder Certification or Proof of Ownership",

            "doccounter_background_check": "Professional License or Certification of the Accountant or Auditor",
            "professional_accountant_license": "Copy of the Professional License for the accountant or auditor"
        }

    }

}
